module.exports = "https://coursera_assets.s3.amazonaws.com/images/49d598d7dcb3b4c6a31839f7f18a15c2.svg";